
import { Options, Vue } from "vue-class-component";
import PosService from "../../service/PosService.js";
import ProfilerService from "../../service/ProfilerService.js";
import ChartService from "../../service/ChartService.js";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf, helpers, maxLength } from "@vuelidate/validators";
import Toaster from "../../helpers/Toaster";
import moment from "moment";
import AutoComplete from "primevue/autocomplete";
import SearchFilter from "../../components/SearchFilter.vue";
import PreviewAccountingReceipt from "../../components/PreviewAccountingReceipt.vue";
import { ref, defineComponent, toRefs, reactive } from "vue";
import PaymentScreen from "../../components/PaymentScreen.vue";
import { useStore, ActionTypes } from "../../store";
import ProfilerDialog from "../../components/ProfilerDialog.vue";
import { ItemList } from "../pos_receipt/IPosReceipt";
import router from "../../router";
import InputNumber from "primevue/inputnumber";
import Chips from "primevue/chips";
import CashierSession from "../../service/CashierSession";

interface PaymentListType {
  paymentType: string;
  accountNo: string;
  terminalId: string;
  authCode: string;
  transId: string;
  transStatus: string;
  transType: string;
  transDate: string;
  transTime: string;
  transAmount: number;
  transTotalAmount: number;
  transRef: string;
  entryMode: string;
  hostResponse: string;
  giftCardRef: string;
  cardBalance: string;
  tendered: number;
  change: number;
  roundOff: number;
}

interface CounterEntry {
  accountID: number;
  accountHead: string;
  amount: number;
  type: string;
}

@Options({
  title: 'Orders',
  components: {
    AutoComplete,
    SearchFilter,
    PreviewAccountingReceipt,
    PaymentScreen,
    ProfilerDialog,
    Chips,
  },

  //adding this option to make the unit price calculation at the item select event
  watch: {
      savedItemList: {
        handler(newList) {
          // Find the newly added item
          const newItem = newList.find(item => !this.previousItemList.some(prevItem => prevItem.stockID === item.stockID));
          if (newItem) {
            this.setPricing(newItem);
          }

          // Update previousItemList
          this.previousItemList = [...newList];
          
          if(newItem){

            setTimeout(() => {
              // need to focus the Unit Qty here
              this.focusNext('item-unit-' + newItem.rowID, null, null);
            }, 100);
          }
        },
        deep: true, // Ensures that changes in nested properties are also detected
      },
      'state.chippedTel': {
        handler(newVal) {
          if (newVal.length === 0) {
            this.triggerDelayedTel(true);
          } else {
            this.delayedChippedTel = false;
          }
        },
        immediate: true,
        deep: true,
      },

    }
})

export default class PosReceipt extends Vue {
  private modeList = [
    { label: "SALE", value: "INE" },
    { label: "REFUND", value: "RFD" },
    // { label: "TRANSFER", value: "TRN" },
  ];
  private unitType = ["Pack", "Strip", "Unit"];
  private discountType = [{key:2, name:"Flat"},{key:1, name:"Percentage"}];
  private invoiceDiscount = 0;
  private discType = "Flat";
  private paymentDialog = false;
  private profileStatus = false;
  private statusType = "New";
  private storeName = "Loading...";
  private removeProfileDialog = false;
  private submitted = false;
  private defaultCustomerName = "";
  private defaultCustomerID = 0;
  private currentUserID = 0;
  private itemScanBox = "";
  private dialogTitle = "";
  private screenMode = "minimize";
  private profilerService;
  private posService;
  private toast;
  private storeList = [];
  private profilerList = [];
  private itemList = [];
  private store = useStore();
  private isToggled = "";
  private delayedChippedTel: boolean= false;
  private cashPaymentOption = true;
  private cardPaymentOption = true;
  private payLaterOption = true;
  private validationPopupMessage = 'Please fill all the required fields to proceed';
  private validationPopup = false;
  private profileTypes = [
    {key:'Customer'}
  ];
  private cashierService;
  private firstElement;

  private counterEntry: CounterEntry [] = [];

  private screenState = reactive({
    fullscreen: false,
    teleport: true,
    pageOnly: false,
  });

  private selectedTaxes = {
    tax1: false,
    tax2: false,
    tax3: false,
  };

  private taxNames = [
    {
      taxName: "",
      show: false,
      optionalReq: "",
      taxValue: 0,
      accountHead: "",
      accountID: 0,
    },
    {
      taxName: "",
      show: false,
      optionalReq: "",
      taxValue: 0,
      accountHead: "",
      accountID: 0,
    },
    {
      taxName: "",
      show: false,
      optionalReq: "",
      taxValue: 0,
      accountHead: "",
      accountID: 0,
    },
  ];

  private state = reactive({
    selectedProfile: "",
    chippedProfile: [] as string[],
    customerTel: "",
    chippedTel: [] as string[],
    transferStoreID: "",
  });

  private savedItemList: ItemList[] = [];
  private previousItemList: ItemList[] = [];

  private validationRules = {
    selectedProfile: {
      required,
    },
    transferStoreID: {
      required: helpers.withMessage(
        "Transfer Store is required",
        requiredIf(() => {
          return this.item.type == "TRN";
        })
      ),
    },
  };

  private paymentList: PaymentListType [] = [];

  private item = {
    id: 0,
    profileID: this.defaultCustomerID,
    discount: 0,
    totalPaid: 0,
    totalTendered: 0,
    totalChange: 0,
    totalGrossAmt: 0,
    invoiceDiscount: 0,
    discType: "",
    totalCost: 0,
    totalBill: 0,
    totalTax1: 0,
    totalTax2: 0,
    totalTax3: 0,
    totalTax: 0,
    description: "",
    paymentMethod: "",
    doctorDetails: "",
    patientDetails: "",
    searchReceiptNo: "",
    status: "Active",
    type: "INE",
  };

  private v$ = useVuelidate(this.validationRules, this.state);

  //DEFAULT METHOD OF TYPE SCRIPT
  created() {
    this.profilerService = new ProfilerService();
    this.posService = new PosService();
    this.toast = new Toaster();
    this.cashierService = new CashierSession();
  }

  selectAll(event) {
    event.target.select(); // selects all text on focus
  }

  mounted() {
    this.checkPaymentPermission();
    this.loadList();
    localStorage.setItem('pos_items', '0');
 
    window.addEventListener('keypress', this.handleKeypress);
    this.focusNext('pos-input', null, null);
  }

  focusNext(refName, event, special) {

    var tempElement = document.getElementById(refName);
    if(special){
      // for special cases
      if(special == 'back_to_item_search'){ // this if for Item menu
        if(!tempElement){
          tempElement = document.getElementById('pos-input');
        }
      }
      else if(special == 'back_to_item_customer'){ // this if for Item menu
        if(!tempElement){
          tempElement = document.getElementById('custPhone');
        }
      }
      else if(special == 'search_bar'){
        const wrapper = document.getElementById('pos-input');
        if(wrapper){
          const span = wrapper.closest('span');
          if (span && span.getAttribute('aria-expanded') === 'true') {
            // console.log('Dropdown is visible');
            return;
          }
        }
      }

      if(special != 'seatch_bar'){
        if (event) {
          event.preventDefault();
        }
      }
    }

    if(tempElement){
      tempElement.focus();
    }

  }

  beforeUnmount() {
    // Remove event listener
    window.removeEventListener('keypress', this.handleKeypress);
  }

  handleKeypress(event) {
    if(!this.paymentDialog){

      // console.log('Key pressed:', event.key, 'KeyCode:', event.keyCode);
      if (event.keyCode == 63) { // Key "*"
        // if only has a one result, itll add that result to the items list
        event.preventDefault();
        this.focusNext('custPhone', null, null);
        
        return '';
      }
      // - = 45,  delete 127, \ = 92
      if (event.keyCode == 42) { // Key "*"
        // if only has a one result, itll add that result to the items list
        event.preventDefault();
        const el = document.getElementById('nextBtn');
        if (el instanceof HTMLButtonElement && !el.disabled){
          if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
          }

          el.click();
        } else {
          this.validationPopupMessage = "Please fill the required fields and proceed";
          this.validationPopup = true;
        }

        return '';
      }
      if (event.keyCode === 43) { // Key "+"
        event.preventDefault();  // Stop default typing of '\'
        this.focusNext('pos-input', null, null);
        
        return '';
      }
      if (event.keyCode === 124) { // Key "|" (shift + \)
        //  go to POS-Refund
        router.push({ path: "/pos-refund" });
        return '';
      }
      if (event.keyCode === 123) { // F12 example
        // console.log('F12 was pressed!');
      }
    }
  }

  closeValidationPopup(){
    this.validationPopup = false;
  }

  // Trigger the 'ArrowDown' key to select the first item
  triggerKeyPress(key: string, input: HTMLInputElement) {
      const event = new KeyboardEvent('keypress', {
        key: key,
        code: key,
        bubbles: true,
        cancelable: true,
      });

      setTimeout(() => {
        
      input.dispatchEvent(event); // Dispatch the key event on the input
      }, 1000);
    }

  toggleScreen() {
    this.screenState.fullscreen = !this.screenState.fullscreen;
  }

  get progressBar() {
    return this.store.getters.getProgressBar;
  }

  searchProfiler(event) {
    setTimeout(() => {
      let param = event.query.trim();
      if (param && param.startsWith('0')) {
        param = param.replace(/^0+/, '');
      }
      this.profilerService.searchProfiler(param, 'Customer').then((data) => {
        this.profilerList = data.records;
        data.records.forEach((record) => {
            if (record.contact_no === param && data.records.length === 1){
              const event = { value: data.records[0] };
              this.saveProfile(event);
            }
        }); 
               
      });
    }, 200);
  }

  searchItem(event) {
    setTimeout(() => {
      this.posService.searchPosItem(event.query.trim()).then((data) => {
        
        if(data.records.length == 0){
          this.itemList = [];
          this.toast.showInfo('No Item Found');
        } else {
          this.itemList = data.records;
          
          this.focusNext('pos-input', null, null);
        }
      });
    }, 200);
  }

  saveProfile(event) {
  const profileInfo = event.value;
  this.state.selectedProfile = profileInfo.account_title;

  this.state.customerTel = profileInfo.contact_no.replace(/^0+/, '');

  // Add the contact number to chippedTel if it is not already present
  if (!this.state.chippedTel.includes(this.state.customerTel)) {
    this.state.chippedTel.push(this.state.customerTel);
  }

  // Add the account title to chippedProfile if it is not already present
  if (!this.state.chippedProfile.includes(profileInfo.account_title)) {
    this.state.chippedProfile.push(profileInfo.account_title);
  }

  // Set the profile ID
  this.item.profileID = profileInfo.id;
}

triggerDelayedTel(value) {
    setTimeout(() => {
      this.delayedChippedTel = value;
    }, 20); // Adjust the delay as needed (200ms here)
  }

  saveItem(event) {
    const itemInfo = event.value;

    let sellRate = 0;
    let disc = 0;

    if (this.item.type != "TRN") {
      sellRate = itemInfo.sale_price;
      disc = itemInfo.discount_percentage;
    } else {
      sellRate = itemInfo.purchase_price;
      disc = 0;
    }

    var batchExists = this.savedItemList.find(batch => batch.stockID == itemInfo.id);
    
    if (!batchExists) {
      this.savedItemList.push({
        rowID: this.savedItemList.length + 1,
        mode: "Unit",
        stockID: itemInfo.id,
        productID:itemInfo.product_id,
        productName: itemInfo.product_name,
        generic: itemInfo.generic_name,
        itemDescription: itemInfo.description,
        unit: 1,
        totalUnit: 0,
        stockQty: Number(itemInfo.qty),
        freeUnit: 0,
        supplierBonus: 0,
        batchNo: itemInfo.batch_no,
        packSize: Number(itemInfo.pack_size),
        sheetSize: Number(itemInfo.strip_size),
        purchasePrice: Number(itemInfo.purchase_price),
        originalPPrice: Number(itemInfo.purchase_price),
        originalSPrice: Number(sellRate),
        sellingPrice: Number(sellRate),
        mrp: Number(itemInfo.mrp),
        brandName: itemInfo.bName,
        sectorName: itemInfo.bSector,
        categoryName: itemInfo.cName,
        productType: itemInfo.pType,
        expiryDate: itemInfo.expiry_date,
        itemDisc: Number(disc),
        tax1: Number(itemInfo.tax_1),
        tax2: Number(itemInfo.tax_2),
        tax3: Number(itemInfo.tax_3),
        subTotal: 0,
      });
      localStorage.setItem('pos_items', '1');
    } else  if(batchExists){
      batchExists.unit = batchExists.unit + 1;
    } else {
      this.toast.showInfo(' Item already added');
    }
    this.itemScanBox = "";

  }
  
  loadList() {
    this.posService.getItems().then((data) => {
      // //taxNames
      this.taxNames = [];

      this.storeList = data.stores;

      this.taxNames.push({
        taxName: data.storeTaxes[0].tax_name_1,
        show: data.storeTaxes[0].show_1 == "true" ? true : false,
        optionalReq: data.storeTaxes[0].required_optional_1,
        taxValue:
          data.storeTaxes[0].show_1 == "true"
            ? Number(data.storeTaxes[0].tax_value_1)
            : 0,
        accountHead: data.storeTaxes[0].tax_name1.chartName,
        accountID: data.storeTaxes[0].link1,
      });

      this.taxNames.push({
        taxName: data.storeTaxes[0].tax_name_2,
        show: data.storeTaxes[0].show_2 == "true" ? true : false,
        optionalReq: data.storeTaxes[0].required_optional_2,
        taxValue:
          data.storeTaxes[0].show_2 == "true"
            ? Number(data.storeTaxes[0].tax_value_2)
            : 0,
        accountHead: data.storeTaxes[0].tax_name2.chartName,
        accountID: data.storeTaxes[0].link2,
      });

      this.taxNames.push({
        taxName: data.storeTaxes[0].tax_name_3,
        show: data.storeTaxes[0].show_3 == "true" ? true : false,
        optionalReq: data.storeTaxes[0].required_optional_3,
        taxValue:
          data.storeTaxes[0].show_3 == "true"
            ? Number(data.storeTaxes[0].tax_value_3)
            : 0,
        accountHead: data.storeTaxes[0].tax_name3.chartName,
        accountID: data.storeTaxes[0].link3,
      });

      if (
        this.taxNames[0].optionalReq == "Required" &&
        this.taxNames[0].show == true
      ) {
        this.selectedTaxes.tax1 = true;
      }

      if (
        this.taxNames[1].optionalReq == "Required" &&
        this.taxNames[1].show == true
      ) {
        this.selectedTaxes.tax2 = true;
      }

      if (
        this.taxNames[2].optionalReq == "Required" &&
        this.taxNames[2].show == true
      ) {
        this.selectedTaxes.tax3 = true;
      }

      //Default Customer
      this.state.selectedProfile = data.defaultCustomer.account_title;
      this.item.profileID = data.defaultCustomer.id;
      this.defaultCustomerName = data.defaultCustomer.account_title;
      this.defaultCustomerID = data.defaultCustomer.id;
      this.currentUserID    = data.currentUserID;
      this.storeName       = data.storeName;
    });
  }

  getTheSubtotal(data) {
    let totalUnits = this.sumUnitTotalQty(data);

    if (data.stockQty < totalUnits && this.item.type != "RFD") {
      data.unit = 1;
      data.mode = "Unit";
      data.freeUnit = 0;
      this.toast.showError("Item does not have enough stock qty 2");
    }

    const qty = Number(data.unit);
    const price = Number(data.sellingPrice);
    const discount = Number(data.itemDisc);

    const tax1 = this.selectedTaxes.tax1 == true ? Number(data.tax1) : 0;
    const tax2 = this.selectedTaxes.tax2 == true ? Number(data.tax2) : 0;
    const tax3 = this.selectedTaxes.tax3 == true ? Number(data.tax3) : 0;

    const total = qty * price;
    const disAmount = (total / 100) * discount;

    const afterDis = total - disAmount;
    const afterTax = (afterDis / 100) * (tax1 + tax2 + tax3);

    const netTotal = afterDis + afterTax;

    data.subTotal = Number(this.fixDigits(netTotal));

    //TOTAL UNITS
    if (data.mode == "Pack") {
      data.totalUnit = (data.packSize * data.unit) + data.freeUnit;
    } else if (data.mode == "Strip") {
      data.totalUnit = (data.sheetSize * data.unit) + data.freeUnit;
    } else {
      data.totalUnit = data.unit + data.freeUnit;
    }

    return this.fixDigits(netTotal);
  }

  getTopMostItem(){
    return this.savedItemList.length;
  }

  getBottomMostItem(){
    return (this.savedItemList.length - this.savedItemList.length) + 1;
  }

  //This part prevent unneccessary characters being entered in the qty input field
  validateUnit(savedItem, event) {
    // Get the input value
    let inputValue = event.target.value;
//console.log(event.target.value);
    // Allow digits and a single decimal point
    let numericValue = inputValue.replace(/[^0-9.]/g, '');

    // Ensure only one decimal point is allowed
    const parts = numericValue.split('.');
    if (parts.length > 2) {
      // If there are more than one ".", join only the first two parts with a single "."
      numericValue = `${parts[0]}.${parts.slice(1).join('')}`;
    }

    // Parse the value and ensure it's a valid number, allowing intermediate "." inputs
    const finalValue = isNaN(Number(numericValue)) ? numericValue : Number(numericValue);

    // Update savedItem.unit with valid value (keeping as numeric when possible)
    savedItem.unit = finalValue;

    // Update the input field value directly, allowing user to see the current input
    event.target.value = numericValue;
  }


  //This part prevent unneccessary characters being entered in the qty input field
  validateDisc(savedItem, event) {
    // Get the input value
    let inputValue = event.target.value;
    
    // Allow digits and a single decimal point
    let numericValue = inputValue.replace(/[^0-9.]/g, '');

    // console.log('Inp:' + inputValue + ' | Numeric: ' + numericValue);

    if(numericValue < 0){
      numericValue = 0;
    }

    if(numericValue > 100){
      numericValue = 100;
    }

    // Parse the value and ensure it's a valid number, allowing intermediate "." inputs
    const finalValue = isNaN(Number(numericValue)) ? numericValue : Number(numericValue);
    savedItem.itemDisc = finalValue;

    // Update the input field value directly, allowing user to see the current input
    event.target.value = numericValue;
  }

  get totalGross() {
    let total = 0;
    this.savedItemList.forEach((e) => {
      total = total + e.sellingPrice * e.unit;
    });

    return total;
  }
  
  get totalCostInventory() {
    let total = 0;
    this.savedItemList.forEach((e) => {
      total = total + e.purchasePrice * e.unit;
    });

    return total;
  }

  get totalTax1() {
    let total = 0;

    this.savedItemList.forEach((e) => {
      const tax = this.selectedTaxes.tax1 == true ? Number(e.tax1) : 0;
      const price = e.sellingPrice * e.unit;
      const afterDisc = (price / 100) * e.itemDisc;
      total = total + ((price - afterDisc) / 100) * tax;
    });

    return Number(total.toFixed(2));
  } 

  get totalTax2() {
    let total = 0;
    this.savedItemList.forEach((e) => {
      const tax = this.selectedTaxes.tax2 == true ? Number(e.tax2) : 0;
      const price = e.sellingPrice * e.unit;
      const afterDisc = (price / 100) * e.itemDisc;
      total = total + ((price - afterDisc) / 100) * tax;
    });

    return Number(total.toFixed(2));
  }

  get totalTax3() {
    let total = 0;
    this.savedItemList.forEach((e) => {
      const tax = this.selectedTaxes.tax3 == true ? Number(e.tax3) : 0;
      const price = e.sellingPrice * e.unit;
      const afterDisc = (price / 100) * e.itemDisc;
      total = total + ((price - afterDisc) / 100) * tax;
    });

    return Number(total.toFixed(2));
  }

  get totalDiscAmount() {
    let total = this.itemDiscAmount + this.extraDiscAmount
    return total;
  }

  get itemDiscAmount(){
    let itemtotal = 0;
    this.savedItemList.forEach((e) => {
      const price = e.sellingPrice * e.unit;
      itemtotal = itemtotal + (price / 100) * e.itemDisc; 
    });
    return itemtotal;
  }

  get extraDiscAmount(){
    let extraDiscVal = 0;
    const itemtotal = this.itemDiscAmount;
    const invoiceDiscount = Number(this.invoiceDiscount) || 0;
    if (this.discType == "Flat"){
      extraDiscVal = invoiceDiscount;
    }
    else {
      extraDiscVal = ((this.totalGross - itemtotal) / 100) * invoiceDiscount;
    }
    return extraDiscVal;
  }

  get netTotal() {
    return Number(
      (
        this.totalGross -
        this.totalDiscAmount +
        this.totalTax1 +
        this.totalTax2 +
        this.totalTax3
      ).toFixed(2)
    );
  }

  get netTotalBeforDisc() {
    return Number(
      (
        this.totalGross +
        this.totalTax1 +
        this.totalTax2 +
        this.totalTax3
      ).toFixed(2)
    );
  }

  setPricing(data) {
    if (data.mode == "Pack") {
      data.sellingPrice = data.originalSPrice;
      data.purchasePrice = data.originalPPrice;
    } else if (data.mode == "Strip") {
      if (data.sheetSize != 0) {
        data.sellingPrice = (data.originalSPrice / data.packSize) * data.sheetSize;
        data.purchasePrice = data.originalPPrice / data.sheetSize;
      }
    } else {
      if (data.packSize != 0) {
        data.sellingPrice = data.originalSPrice / data.packSize;
        data.purchasePrice = data.originalPPrice / data.packSize;
      }
    }
  }

  fixDigits(amt) {
    let total = 0;
    if (amt != null) {
      total = amt.toFixed(2);
    }
    return total;
  }

  clearAll(msg = false){
    this.state.selectedProfile = this.defaultCustomerName;
    this.state.customerTel = "";
    this.state.transferStoreID = "";
    this.state.chippedProfile = [];
    this.state.chippedTel = [];

    this.savedItemList = [];
    this.paymentList =  [];

    this.item = {
      id: 0,
      profileID: this.defaultCustomerID,
      discount: 0,
      totalGrossAmt: 0,
      invoiceDiscount: 0,
      discType: "",
      totalCost: 0,
      totalBill: 0,
      totalPaid: 0,
      totalTendered: 0,
      totalChange: 0,
      totalTax1: 0,
      totalTax2: 0,
      totalTax3: 0,
      totalTax: 0,
      description: "",
      searchReceiptNo: "",
      paymentMethod: "",
      doctorDetails: "",
      patientDetails: "",
      status: "Active",
      type: this.item.type,
    };

    this.itemScanBox = "";
    this.invoiceDiscount = 0;
    if(msg){
      this.toast.showSuccess("Items Removed Successfully");
    }

    localStorage.setItem('pos_items', '0');
    this.focusNext('pos-input', null, null);
  }

  clearAllManually() {
    if(this.savedItemList.length == 0){
      this.toast.showInfo("Nothing to remove");
      return;
    }
    const answer = window.confirm("Do you want to remove those items?");
    if (answer) {
      this.clearAll(true);
    } else {
      // do nothing
    }
  }

  changeInvoiceDiscount(){
    this.invoiceDiscount = 0;
  }

  formatExpiryDate(d) {
    return moment(d).format("MMM-YYYY");
  }

  adjustQty(type, item) {
    
    if (type == "minus" && item.unit > 1) {
      item.unit--;
    } else if (type == "add") {
      if (
        item.unit + item.freeUnit < item.stockQty ||
        this.item.type == "RFD"
      ) {
        item.unit++;
      } else {
        this.toast.showError("Item does not have enough stock qty");
      }
    }
  }

  adjustFreeQty(type, item) {
    if (type == "minus" && item.freeUnit > 0) {
      item.freeUnit--;
    } else if (type == "add") {
      if (item.unit + item.freeUnit < item.stockQty) {
        item.freeUnit++;
      } else {
        this.toast.showError(
          "Item does not have enough stock qty to provide free units"
        );
      }
    }
  }

  adjustDisc(type, item) {
    if (type == "minus" && item.itemDisc > 0) {
      item.itemDisc--;
    } else if (type == "add" && item.itemDisc <100) {
      item.itemDisc++;
    }
  }

  clearListItem(item) {
    const answer = window.confirm("Do you want to remove this item?");
    if (answer) {
      this.savedItemList.splice(this.savedItemList.indexOf(item), 1);
      this.toast.showSuccess("Item Deleted Successfully");
      this.focusNext('pos-input', null, null);
      // for the notification of leave page
      if(this.savedItemList.length == 0){
        localStorage.setItem('pos_items', '0');
      }
    } else {
      // do nothing
    }
  }

  limitString(str) {
    if (str.length > 40) str = str.substring(0, 40) + "...";
    return str;
  }


  closePaymentScreen() {
    this.paymentDialog = false;
  }

  getProceededPayments(paymentList, isToggled) {
    this.paymentList = paymentList;
    const tenderedList = this.getTotalPaid(paymentList);
    this.item.totalPaid = Number(tenderedList[0]);
    this.item.totalTendered = Number(tenderedList[1]);
    this.item.totalChange = Number(tenderedList[2]);

    const payedMethod = this.getPaymentMethod(paymentList);
    this.item.paymentMethod = payedMethod.payMethod;

    this.item.discType = this.discType;
    this.item.invoiceDiscount = this.invoiceDiscount;
    this.item.discount = this.totalDiscAmount;
    this.item.totalGrossAmt = this.totalGross;
    this.item.totalCost = this.totalCostInventory;
    this.item.totalBill = this.netTotal;
    this.item.totalTax1 = this.totalTax1;
  this.item.totalTax2 = this.totalTax2;
    this.item.totalTax3 = this.totalTax3;
    this.item.totalTax = Number(
      this.totalTax1 + this.totalTax2 + this.totalTax3
    );

    this.setAccountingEntries();

    this.posService
      .saveItem(this.item, this.paymentList, this.state, this.savedItemList, this.counterEntry, true)
      .then((res) => {
        //console.log("POS ITEM SAVED SUCCESSFULLY");
        if (res.original.alert == "info") {
          this.clearAll();
          this.toast.showSuccess(res.original.msg);
          // if (isToggled === 'Pos Receipt'){
          //   this.generatePosReceipt(res);
          // } 
          this.generatePosReceipt(res);
        }
      });

    this.paymentDialog = false;
    this.submitted = false;
  }

  generatePosReceipt(res){
    if (res.original.htmlTemplate) {
                 // Open a new window and write the HTML content to it
                 const printWindow = window.open('', '_blank');
                if (printWindow !== null) {
                    printWindow.document.open();
                    printWindow.document.write(`
                        <html>
                            <head>
                                <title>Print Receipt</title>
                            </head>
                            <body onload="setTimeout(function() { window.print(); window.close(); }, 300)">
                                ${res.original.htmlTemplate} <!-- HTML content from the response -->
                            </body>
                        </html>
                    `);
                    printWindow.document.close(); // Close the document
                    // printWindow.focus(); // Focus on the new window
                    // printWindow.print(); // Trigger the print dialog
                    // printWindow.close(); // Close the window after printing
                }
            }
  }

  validateItems(){
    let validated = 1;
    let errorMessage = '';
  
    // check for duplicates
    const seen = new Set();
    this.savedItemList.filter((item) => {
      if(!(item.unit > 0)){
        errorMessage = 'Please fill all the required fields to proceed'; // if item is already in the Set, it's a duplicate
        validated = 0;
      }
      if (seen.has(item.productID+item.batchNo)) {
        errorMessage = 'Batch Numbers cannot be duplicate for a single product'; // if item is already in the Set, it's a duplicate
        validated = 0;
      } else {
        seen.add(item.productID+item.batchNo); // if not, add it to the Set
      }
    });

    return {status: validated, message: errorMessage};
  }

  openPaymentMethod(isFormValid) {
    
    let validateDetails = this.validateItems();
    // console.log(validateDetails);
    if(validateDetails.status == 0){
      this.validationPopupMessage = validateDetails.message;
      this.validationPopup = true;
      return false;
    }

    this.submitted = true;
    if (isFormValid = true) {
      if(this.state.customerTel === ""){
        this.isToggled = "Pos Receipt"
      }else {
        this.isToggled ="E Receipt"
      }
      this.paymentDialog = true;
      this.store.dispatch(
        ActionTypes.TOTAL_BILL,
        Number(this.fixDigits(this.netTotal))
      );
    }
  }

  get totalPaidCash()
  {
    let total = 0;

    this.paymentList.forEach(e => {
      if(e.paymentType == 'Cash')
      {
        total = total + e.transTotalAmount;
      }
    });

    return total;
  }

  get totalPaidBank()
  {
    let total = 0;

    this.paymentList.forEach(e => {
      if(e.paymentType != 'Cash')
      {
        total = total + e.transTotalAmount;
      }
    });

    return total;
  }

  getTotalPaid(paymentList) {
    let totalPaid = 0;
    let totalTendered = 0;
    let totalChange = 0;

    paymentList.forEach((e) => {
      if (e.paymentType != "Tip") {
        totalPaid = totalPaid + Number(e.transTotalAmount);
        totalTendered = totalTendered + Number(e.tendered);
        totalChange = totalChange + Number(e.change);
      }
    });

    return [totalPaid, totalTendered, totalChange];
  }

  get totalBalance()
  {
    return this.netTotal - this.item.totalPaid;
  }

  getPaymentMethod(paymentList) {
    let payMethod = "";
    let payMethodId = 0;

    if (paymentList.length == 0) {
      payMethod = "Pay Later";
      payMethodId = 2;
    } else if (paymentList.length == 1) {
      payMethod = paymentList[0].paymentType;
      payMethodId = paymentList[0].paymentTypeID;
    } else if (paymentList.length > 1) {
      payMethod = "Split";
      payMethodId = 0;
    }

    return {payMethod:payMethod, paymentMethodId:payMethodId};
  }

  shiftPos(){
    if(this.item.type == "TRN") {
      this.toast.showSuccess("Mode Changed Successfully");
      this.clearAll();
    }
    if (this.item.type != "TRN") {
      this.savedItemList.forEach((e) => {
        e.freeUnit = 0;
      });
    }

    if (this.item.type == "RFD") {
      window.open('/pos-refund', '_blank');
      this.item.type = 'INE';
    }
    this.submitted = false;
  }

  sumUnitTotalQty(data) {
    let totalUnits = 0;

    this.savedItemList.forEach((e) => {
      if (data.stockID == e.stockID) {
        if (e.mode == "Pack") {
          totalUnits = totalUnits + (e.packSize  * e.unit)  + e.freeUnit;
        } else if (e.mode == "Strip") {
          totalUnits = totalUnits + (e.sheetSize * e.unit)  + e.freeUnit;
        } else {
          totalUnits = totalUnits + (e.freeUnit + e.unit);
        }
      }
    });

    return Number(totalUnits);
  }

  //OPEN DIALOG TO ADD NEW ITEM
  openProfileDialog() {
    this.dialogTitle = "Add New Customer";
    this.profileStatus = true;
    this.statusType = "New";
  }  
  
  logoutCashier() {
    const answer = window.confirm("Do you want to logout from Cashier Session?");
    if (answer) {
      this.cashierService
        .logoutCashier()
        .then((res) => {
          if (res.status_id == 1) {
            this.toast.showInfo(res.msg);
            this.store.dispatch(ActionTypes.CASHIER_SESSION, "");
            router.push({ path: "/home/dashboard" });
          } else {          
            this.toast.handleResponse(res);
            router.push({ path: "/home/dashboard" });
          }
        });

      this.paymentDialog = false;
      this.submitted = false;
      
    } else {
      // do nothing
    }

  }

  removeProfile(event){
    this.state.selectedProfile= "";
    this.state.customerTel = "";
    this.state.chippedProfile = [];
    this.state.chippedTel = [];
    this.item.profileID = 1;
 
     // Remove only the specific profile and contact number
    const chipIndex = this.state.chippedTel.indexOf(event.value);
    
    if (chipIndex !== -1) {
      this.state.chippedTel.splice(chipIndex, 1);
      this.state.chippedProfile.splice(chipIndex, 1);
 
      // Clear additional state only if no chips remain
      if (this.state.chippedTel.length === 0) {
        this.state.selectedProfile = "";
        this.state.customerTel = "";
      }
    }
  }

  updateProfilerStatus(res) {
    this.profileStatus = false;
    if (res[0] == "load") {
      this.state.selectedProfile = res[1].account_title;
      this.state.customerTel = res[1].contact_no;
      this.item.profileID = res[1].id;
    }
  }

  redirectHome()
  {
    this.screenState.fullscreen = false;
    router.replace({ path: "/home/dashboard", });
  }

  isExpiryDateCritical(date: { expiry_date: string }): string {
    const today = new Date();
    const expiryDate = new Date(date.expiry_date);
    const diffTime = expiryDate.getTime() - today.getTime(); // Use getTime() to get milliseconds
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    
    if(diffDays < 0){
      return 'expired-date'
    }else if(diffDays <= 31 && diffDays > 0){
      return 'expired-date-month'
    }else if(diffDays <= 92 && diffDays >=31){
      return 'expired-date-3months'
    }else if(diffDays <= 183 && diffDays >=92){
      return 'expired-date-6months'
    }else{
      return ''
    } 
  }

  setAccountingEntries() {
   
    this.counterEntry = [];

    if (this.item.type == "INE") {
      if (this.totalBalance == 0) {

        if (this.totalPaidCash > 0) {
          this.counterEntry.push({
            accountID: 2,
            accountHead: 'Cash in hand',
            amount: this.totalPaidCash,
            type: "Debit",
          });
        }
        
        if (this.totalPaidBank > 0) {
          this.counterEntry.push({
            accountID: 8,
            accountHead: 'Cash at bank',
            amount: this.totalPaidBank,
            type: "Debit",
          });
        }

      } else if (this.totalBalance == this.netTotal) {
        this.counterEntry.push({
          accountID: 4,
          accountHead: "Accounts receivable",
          amount: this.netTotal,
          type: "Debit",
        });
      } else if(this.totalBalance > 0 && this.item.totalPaid > 0) {
          if (this.totalPaidCash > 0) {
            this.counterEntry.push({
              accountID: 2,
              accountHead: 'Cash in hand',
              amount: this.totalPaidCash,
              type: "Debit",
            });
          }
          
          if (this.totalPaidBank > 0) {
            this.counterEntry.push({
              accountID: 8,
              accountHead: 'Cash at bank',
              amount: this.totalPaidBank,
              type: "Debit",
            });
          }

          this.counterEntry.push({
            accountID: 4,
            accountHead: "Accounts receivable",
            amount: this.totalBalance,
            type: "Debit",
          });
      }

        this.counterEntry.push({
          accountID: 56,
          accountHead: 'Cost of Goods',
          amount: this.totalCostInventory,
          type: "Debit",
        });
        
        
        this.counterEntry.push({
          accountID: 48,
          accountHead: 'Sales Revenue',
          amount: this.totalGross-this.totalDiscAmount,
          type: "Credit",
        });

        this.counterEntry.push({
          accountID: 3,
          accountHead: 'Inventory',
          amount: this.totalCostInventory,
          type: "Credit",
        });

      //ADDING TAXES
      if (this.totalTax1 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[0].accountID,
          accountHead: this.taxNames[0].accountHead,
          amount: this.totalTax1,
          type: "Credit",
        });
      }

      if (this.totalTax2 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[1].accountID,
          accountHead: this.taxNames[1].accountHead,
          amount: this.totalTax2,
          type: "Credit",
        });
      }

      if (this.totalTax3 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[2].accountID,
          accountHead: this.taxNames[2].accountHead,
          amount: this.totalTax3,
          type: "Credit",
        });
      }
    } else if(this.item.type == "RFD") {

        this.counterEntry.push({
          accountID: 48,
          accountHead: 'Sales Revenue',
          amount: this.totalGross-this.totalDiscAmount,
          type: "Debit",
        });

        this.counterEntry.push({
          accountID: 3,
          accountHead: 'Inventory',
          amount: this.totalCostInventory,
          type: "Debit",
        });

      //ADDING TAXES
      if (this.totalTax1 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[0].accountID,
          accountHead: this.taxNames[0].accountHead,
          amount: this.totalTax1,
          type: "Debit",
        });
      }

      if (this.totalTax2 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[1].accountID,
          accountHead: this.taxNames[1].accountHead,
          amount: this.totalTax2,
          type: "Debit",
        });
      }

      if (this.totalTax3 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[2].accountID,
          accountHead: this.taxNames[2].accountHead,
          amount: this.totalTax3,
          type: "Debit",
        });
      }

      if (this.totalBalance == 0) {

        if (this.totalPaidCash > 0) {
          this.counterEntry.push({
            accountID: 2,
            accountHead: 'Cash in hand',
            amount: this.totalPaidCash,
            type: "Credit",
          });
        }
        
        if (this.totalPaidBank > 0) {
          this.counterEntry.push({
            accountID: 8,
            accountHead: 'Cash at bank',
            amount: this.totalPaidBank,
            type: "Credit",
          });
        }

      } else if (this.totalBalance == this.netTotal) {
        this.counterEntry.push({
          accountID: 5,
          accountHead: "Accounts payable",
          amount: this.netTotal,
          type: "Credit",
        });
      } else if(this.totalBalance > 0 && this.item.totalPaid > 0) {
          if (this.totalPaidCash > 0) {
            this.counterEntry.push({
              accountID: 2,
              accountHead: 'Cash in hand',
              amount: this.totalPaidCash,
              type: "Credit",
            });
          }
          
          if (this.totalPaidBank > 0) {
            this.counterEntry.push({
              accountID: 8,
              accountHead: 'Cash at bank',
              amount: this.totalPaidBank,
              type: "Credit",
            });
          }

          this.counterEntry.push({
            accountID: 5,
            accountHead: "Accounts payable",
            amount: this.totalBalance,
            type: "Credit",
          });
      }

        this.counterEntry.push({
          accountID: 56,
          accountHead: 'Cost of Goods',
          amount: this.totalCostInventory,
          type: "Credit",
        });
    }
    else
    {
      //TRANSFER ENTRY NO NEED
    }

  }

  get currency() {
    return this.store.getters.getCurrency;
  }

  checkPaymentPermission(){
          const paymentOptions = ["Card Payment","Cash Payment","Pay Later"];
  
          const store = useStore();
  
          const pL =  JSON.parse(store.getters.gerUserPermissions);
          
          for (let option of paymentOptions) {
            
            const filtered = pL.filter(e => e.name === option);
            let res = false;
  
              if(filtered.length > 0)
              {
                res = true;
              }
              if(res && option == 'Card Payment'){
                this.cardPaymentOption = true;
              }else if(res && option == 'Cash Payment'){
                this.cashPaymentOption = true;
              }else if(res && option == 'Pay Later'){
                this.payLaterOption = true;
              }
  
          }
  
          
      }
}

